// external imports
import { Registry } from "react-registry";

// internal imports
import IService from "core/service/IService";
import IMutationService from "core/service/mutation/IMutationService";
import IQueryService from 'core/service/query/IQueryService';
import { AbstractClass, default as Class } from 'core/util/Class';
import { default as TypeUtil, iDef } from 'core/util/TypeUtils';
import ComponentRegistry from "react-registry/dist/lib/ComponentRegistry";
import Logger from "../Logger";
import IPropertyType from "./IPropertyType";

/**
 * @overview:
 *
 * @author: jesposito
 *
 * Usage:
 *
 */

export default class PropertyTypeRegistry {
	private static REGISTRY_PREFIX: string = "__core:propertyType:";
	private static DEFAULT_GROUP: string = "_default";

	private constructor() {
		// this.name = ServiceRegistry.PREFIX + service;
	}

	private static getRegistry(group: string) {
		return PropertyTypeRegistry.REGISTRY_PREFIX + group;
	}

	public static get<T extends IPropertyType<any, any>>(name: string, group: string = PropertyTypeRegistry.DEFAULT_GROUP): T {

		if(typeof name !== "string") {
			Logger.throw("Invalid PropertyTypeId Id. group: %s, name: %s", group, name);
		}

		return Registry.get({
			id: name,
			registry: PropertyTypeRegistry.getRegistry(group)
		}) as T;
	}

	public static getAll<T extends IPropertyType<any, any>>(group: string = PropertyTypeRegistry.DEFAULT_GROUP): T[] {

		const registry = PropertyTypeRegistry.getRegistry(group);

		// use hack to access react-registery interally
		// TODO upadte when react-registry supports getting list of registered components
		return Object.keys((ComponentRegistry.getInstance().getRegistry(registry) as any).registry.map).map((key) => (
			Registry.get({id: key, registry})
		)) as any;
	}

	public static register<C extends IPropertyType<any, any>>(propertyType: C) {
		const regsitryPostfix = propertyType.propertyGroup ? propertyType.propertyGroup : PropertyTypeRegistry.DEFAULT_GROUP;

		// get the registry from the service
		const registry = PropertyTypeRegistry.REGISTRY_PREFIX + regsitryPostfix;

		if(typeof propertyType.name !== "string") {
			Logger.throw("Invalid PropertyTypeId Id. group: %s", regsitryPostfix);
		}

		Logger.debug("Registering { group: %s, name: %s }", registry, propertyType.name);

		// add it to the registry
		Registry.register(propertyType, {id: propertyType.name, registry});
	}
}



// WEBPACK FOOTER //
// ./src/core/util/property/PropertyTypeRegistry.ts